import request from 'superagent'
import types from '../types'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
    api_url = `${protocol}//${hostname}/api`
}

const getTargetGroupsRequested = () => ({
    type: types.GET_TARGET_GROUPS_REQUESTED,
    payload: null
})

const getTargetGroupsFufilled = (data: any) => ({
    type: types.GET_TARGET_GROUPS_FULFILLED,
    payload: data
})

const getTargetGroupsRejected = (error: any) => ({
    type: types.GET_TARGET_GROUPS_REJECTED,
    payload: error
})

export const getTargetGroups = (token: string) => {
    return (dispatch: any) => {
        dispatch(getTargetGroupsRequested())
        request
            .get(`${api_url}/targetgroups`)
            .set('Accept', 'application/json')
            .set('access-token', token)
            .then((response) => {
                dispatch(getTargetGroupsFufilled(response.body))
            })
            .catch((error) => {
                dispatch(getTargetGroupsRejected(error))
            })
    }
}